export default "__VITE_ASSET__BGM4Uf9G__"